<template>
  <v-card flat outlined class="mto-sector-charts pa-4">
    <h3 class="mto-sector-detail__section-title mb-3">Графики участка</h3>

    <v-row>
      <v-col cols="12" md="6">
        <mto-doorphone-status-chart
          embedded
          :doorphones-indicators="doorphonesIndicators"
          :equipment-items="equipmentItems"
          :status-description="statusDescription"
          empty-text="Нет домофонов на участке"
        />
      </v-col>

      <v-col cols="12" md="6">
        <div class="mto-sector-charts__chart-title">Состав оборудования</div>
        <div v-if="hasEquipmentData" class="mto-sector-charts__canvas-wrap">
          <canvas ref="equipmentChart"></canvas>
        </div>
        <div v-else class="mto-sector-charts__empty">
          Нет оборудования на участке
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import Chart from 'chart.js';
import MtoDoorphoneStatusChart from '@/components/reports/MtoDoorphoneStatusChart';

const EQUIPMENT_COLORS = [
  'rgba(25, 118, 210, 0.75)',
  'rgba(76, 175, 80, 0.75)',
  'rgba(255, 152, 0, 0.75)',
  'rgba(156, 39, 176, 0.75)',
  'rgba(0, 188, 212, 0.75)',
  'rgba(121, 85, 72, 0.75)',
];

const EQUIPMENT_LABELS = {
  doorphones: 'Домофоны',
  additional_entrances: 'Доп. входы',
  gates_doorphones: 'Калитки (домофон)',
  gates_readers: 'Калитки (считыватель)',
  barriers: 'Шлагбаумы',
  apartments: 'Всего квартир',
  apartments_with_phone_setup: 'Квартир с возможностью установки трубки',
};

export default {
  name: 'MtoSectorChartsCard',
  components: { MtoDoorphoneStatusChart },
  props: {
    doorphonesIndicators: {
      type: Object,
      default: () => ({}),
    },
    equipmentCounts: {
      type: Object,
      default: () => ({}),
    },
    equipmentItems: {
      type: Array,
      default: () => [],
    },
    statusDescription: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    equipmentChart: null,
  }),
  computed: {
    hasEquipmentData () {
      return Object.keys(EQUIPMENT_LABELS).some((key) => {
        return Number(this.equipmentCounts?.[key] || 0) > 0;
      });
    },
  },
  mounted () {
    this.renderCharts();
  },
  beforeDestroy () {
    this.destroyCharts();
  },
  watch: {
    equipmentCounts: {
      deep: true,
      handler () {
        this.$nextTick(() => this.renderEquipmentChart());
      },
    },
    hasEquipmentData (value) {
      if (value) this.$nextTick(() => this.renderEquipmentChart());
      else this.destroyEquipmentChart();
    },
  },
  methods: {
    renderCharts () {
      this.$nextTick(() => {
        this.renderEquipmentChart();
      });
    },
    buildEquipmentChartData () {
      const labels = [];
      const data = [];
      const backgroundColor = [];

      Object.entries(EQUIPMENT_LABELS).forEach(([key, label], index) => {
        const value = Number(this.equipmentCounts?.[key] || 0);
        if (!value) return;

        labels.push(label);
        data.push(value);
        backgroundColor.push(EQUIPMENT_COLORS[index % EQUIPMENT_COLORS.length]);
      });

      return {
        labels,
        datasets: [{
          data,
          backgroundColor,
          borderColor: 'rgba(76, 108, 147, 1)',
          borderWidth: 1,
        }],
      };
    },
    renderEquipmentChart () {
      if (!this.$refs.equipmentChart) return;

      const chartData = this.buildEquipmentChartData();
      this.destroyEquipmentChart();

      if (!chartData.labels.length) return;

      this.equipmentChart = new Chart(this.$refs.equipmentChart, {
        type: 'horizontalBar',
        data: chartData,
        options: {
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: false,
          },
          scales: {
            xAxes: [{
              ticks: {
                beginAtZero: true,
                precision: 0,
              },
            }],
            yAxes: [{
              ticks: {
                autoSkip: false,
              },
            }],
          },
        },
      });
    },
    destroyEquipmentChart () {
      if (!this.equipmentChart) return;
      this.equipmentChart.destroy();
      this.equipmentChart = null;
    },
    destroyCharts () {
      this.destroyEquipmentChart();
    },
  },
};
</script>

<style lang="scss" scoped>
.mto-sector-charts {
  border-radius: 12px;
}

.mto-sector-charts__chart-title {
  margin-bottom: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  color: #546e7a;
}

.mto-sector-charts__canvas-wrap {
  position: relative;
  height: 260px;
}

.mto-sector-charts__empty {
  height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  color: #90a4ae;
  text-align: center;
  padding: 0 16px;
  background: rgba(0, 0, 0, 0.02);
  border-radius: 10px;
}
</style>
